<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <p-message
        styleClass="w-100"
        *ngIf="loadingMessage.show"
        [severity]="loadingMessage.severity"
        [text]="loadingMessage.text">
    </p-message>

    <div *ngIf="enrollment && privacyPolicy && campusName " class="container-fluid p-4">

        <div class="w-100">

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">

                <span class="text-primary-color fw-bolder">{{labels.privacyPolicyLabel}}</span>

                <div class="text-wrap text-break mb-3" [innerHTML]="privacyPolicy"></div>

                <div class="d-flex flex-column justify-content-start align-items-start">

                    <div class="d-flex flex-row justify-content-start align-items-start w-100">

                        <p-checkbox
                            class="me-2"
                            inputId="conditions"
                            [binary]="true"
                            [(ngModel)]="enrollment.conditionsChecked"
                            (onChange)="onCheckboxChange()">
                        </p-checkbox>

                        <label for="conditions">
                            <span class="text-wrap">Acepto las CONDICIONES del {{ campusName | uppercase }}.</span>
                        </label>

                    </div>

                    <div class="d-flex flex-row justify-content-start align-items-start w-100">

                        <p-checkbox
                            class="me-2"
                            inputId="authorization"
                            [binary]="true"
                            [(ngModel)]="enrollment.authorizationChecked"
                            (onChange)="onCheckboxChange()">
                        </p-checkbox>

                        <label for="authorization">
                            <span class="text-wrap">Otorgo mi autorización para que el/la solicitante participe en su edición actual.</span>
                        </label>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
